import { useSite } from "../../lib/useSite";
import { Eyebrow, Reveal, InsuranceBadges } from "../../components/bits";

const IMG = "https://images.pexels.com/photos/9462636/pexels-photo-9462636.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function About() {
  const site = useSite();
  const b = site?.business || {};
  const areas = site?.service_areas || [];
  return (
    <div>
      <section className="bg-[#0a0a0a] relative">
        <div className="absolute inset-0 noise-overlay" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-16">
          <Eyebrow dark>About</Eyebrow>
          <h1 className="font-display text-[#fdfbf7] text-5xl sm:text-6xl tracking-tight max-w-3xl leading-[1.05]">Premium cleaning, carefully managed</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <img src={IMG} alt="Professional cleaners" className="w-full h-[420px] object-cover rounded-sm border border-[#e8e5de]" />
        </Reveal>
        <Reveal delay={0.1}>
          <div>
            <p className="font-display text-2xl text-[#0a0a0a] leading-relaxed">
              {b.about || "Black Diamond Elite Cleaning provides professional residential and commercial cleaning with premium standards, dependable service and carefully managed customer care."}
            </p>
            <p className="text-[#555] mt-6 leading-relaxed text-sm">
              We operate across {b.primary_area || "North London, NW London and Watford"}, with planned expansion into South London and wider London.
              Our approach is built on organisation, discretion and consistent quality — supported by internal compliance tracking, quality control and reliable communication.
            </p>
            <p className="text-xs text-[#8a8a8a] mt-6">
              We do not publish awards, certifications, insurance numbers or customer figures that have not been confirmed. Individual worker compliance is tracked internally and shown only when verified.
            </p>
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-20">
        <Eyebrow>Service areas</Eyebrow>
        <h2 className="font-display text-3xl tracking-tight mb-6">Where we work</h2>
        <div className="flex flex-wrap gap-3">
          {areas.map((a) => (
            <span key={a.id} className="flex items-center gap-2 border border-[#e0ddd4] px-4 py-2 rounded-sm text-sm">
              <span className={`w-2 h-2 rounded-full ${a.status === "Active" ? "bg-green-500" : a.status === "Limited" ? "bg-amber-500" : a.status === "Coming Soon" ? "bg-[#d4af37]" : "bg-gray-400"}`} />
              {a.name} <span className="text-[#8a8a8a] text-xs">· {a.status}</span>
            </span>
          ))}
        </div>
        <InsuranceBadges site={site} />
      </section>
    </div>
  );
}
